import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Deal } from '@app/models/menu/deal';
import { MenuItemView } from '@app/models/menu/menu-item-view';

export type ProductUpsellOption = {
  name: string;
  deal: Deal;
};

@Component({
  selector: 'app-deal-upsell-modal',
  templateUrl: './deal-upsell-modal.component.html',
  styleUrls: ['./deal-upsell-modal.component.css'],
  standalone: true
})
export class DealUpsellModalComponent {
  @Input({ required: true }) public prompt: string = 'Would you like to make it a meal?';
  @Input({ required: true }) public options: ProductUpsellOption[];
  @Input({ required: true }) public menuItem: MenuItemView;
  @Input({ required: true }) public dialogRef: MatDialogRef<unknown>;

  @Output('onSelectDeal') private _onSelectDeal = new EventEmitter<Deal>();
  @Output('onSelectMenuItem') private _onSelectMenuItem = new EventEmitter<void>();

  constructor() {}

  public selectDeal(deal: Deal): void {
    this._onSelectDeal.emit(deal);
    this.dialogRef.close();
  }

  public selectMenuItem(): void {
    this._onSelectMenuItem.emit();
    this.dialogRef.close();
  }
}
